export enum LISTS {
  KEYWORDS = "Keywords",
  SECTIONS = "Sections",
  QUESTION_TYPES = "QuestionTypes",
  CLIENT_TYPES = "ClientTypes",
  FAQS = "FAQs",
  FAQ_FILES = "FAQFiles",
  COMBINATIONS = "Combinations",
  IMPORT_DATE = "ImportDate"
}

export enum LIST_ACTIONS {
  ADD = "ADD",
  UPDATE = "UPDATE",
  NEW = "NEW",
  NONE = "NONE"
}

export enum RADIO_OPTIONS {
  SYSTEM = "Tekniskt system",
  OPERATION = "Tjänsteområde",
  ALL = "Alla"
}

export enum DISPATCH_TYPE {
  GET_INITIAL_DATA = "GET_INITIAL_DATA",
  GET_IMPORT_FILE_DATA = "GET_IMPORT_FILE_DATA",

  SET_CURRENTUSER = "SET_CURRENTUSER",
  SET_CURRENTUSER_EMAIL = "SET_CURRENTUSER_EMAIL",
  SET_FAQ_DATA = "SET_FAQ_DATA",
  SET_FAQ_FILES = "SET_FAQ_FILES",
  SET_SECTIONS = "SET_SECTIONS",
  SET_QUESTION_TYPES = "SET_QUESTION_TYPES",
  SET_CLIENT_TYPES = "SET_CLIENT_TYPES",
  SET_KEYWORDS = "SET_KEYWORDS",
  SET_IS_LOADING = "SET_IS_LOADING",
  SET_COMBINATIONS = "SET_COMBINATION",
  SET_IMPORT_DATE = "SET_IMPORT_DATE",

  SET_IS_LOGP = "SET_IS_LOGP",

  SET_IMPORT_CLIENT_TYPES = "SET_IMPORT_CLIENT_TYPES",
  SET_IMPORT_COMBINATIONS = "SET_IMPORT_COMBINATIONS",
  SET_IMPORT_FAQS = "SET_IMPORT_FAQS",
  SET_IMPORT_FAQ_FILES = "SET_IMPORT_FAQ_FILES",
  SET_IMPORT_KEYWORDS = "SET_IMPORT_KEYWORDS",
  SET_IMPORT_STATUS = "SET_IMPORT_STATUS",
  SET_IMPORT_SECTIONS = "SET_IMPORT_SECTIONS",
  SET_IMPORT_QUESTION_TYPES = "SET_IMPORT_QUESTION_TYPES",

  SET_FORM_STATE = "SET_FORM_STATE",
  UPDATE_FORM_STATE = "UPDATE_FORM_STATE",
  CLEAR_FORM_STATE = "CLEAR_FORM_STATE"
}

export enum IMPORT_STATUS {
  NONE = "NONE",
  IMPORTING = "IMPORTING",
  DONE = "DONE",
  ERROR = "ERROR"
}

export enum Variant {
  PRIMARY = "primary",
  SUCCESS = "success",
  DANGER = "danger",
  SECONDARY = "secondary"
}

export enum CREATE_NOTIFICATION {
  INFO = "INFO",
  SUCCESS = "SUCCESS",
  WARNING = "WARNING",
  ERROR = "ERROR"
}

export enum FrameColor {
  GREEN = "green",
  BLUE = "blue",
  GREY = "grey",
  YELLOW = "yellow"
}
export enum MatterStatus {
  DRAFT = "Utkast",
  CLOSED = "Stängd",
  READY_TO_CLOSE = "Inväntar stängningsåtgärd",
  ASSIGNED = "Lottad",
  CHECKED_OUT = "Kvitterad",
  AWAITING_DECISION = "Inväntar beslut",
  AWAITING_ANSWER = "Inväntar svar",
  ANONYMIZED = "Utgallrad",
  AUTOMATICALLY_ESCALATED = "Automateskalerad",
  ARCHIVED = "Arkiverad",
  BEING_PREPARED = "Bereds"
}

export const MatterStatusSv: Record<any, string> = {
  [MatterStatus.READY_TO_CLOSE]: "Kundtjänst sammanfattar svar",
  [MatterStatus.ASSIGNED]: "Ärendet skickat",
  [MatterStatus.CHECKED_OUT]: "Ärendet hanteras",
  [MatterStatus.AWAITING_DECISION]:
    "Ärendet hanteras (Inväntar information från 3e part)",
  [MatterStatus.AWAITING_ANSWER]:
    "Ärendet hanteras (Inväntar information från 3e part)",
  [MatterStatus.AUTOMATICALLY_ESCALATED]: "Ärendet hanteras (prioriterat)",
  [MatterStatus.BEING_PREPARED]: "Ärendet hanteras (förlängd hanteringstid)"
};

export enum MatterEventTypes {
  AMENDMENT = "AMENDMENT",
  REASSIGNMENT = "REASSIGNMENT",
  COMMENT = "COMMENT",
  CLOSE_MATTER = "CLOSE_MATTER",
  ARCHIVE = "ARCHIVE",
  REOPEN = "REOPEN",
  REGISTRATION = "REGISTRATION",
  QUESTION = "QUESTION",
  DECIDED = "DECIDED",
  DECISION_QUERY = "DECISION_QUERY",
  ANSWER = "ANSWER",
  ANSWERED = "ANSWERED",
  APPROVED = "APPROVED",
  DENIED = "DENIED",
  BEING_PREPARED = "BEING_PREPARED",
  MATTER_ANSWER = "MATTER_ANSWER",
  UNANSWERED = "UNANSWERED",
  UNDECIDED = "UNDECIDED",
  SENT_BACK = "SENT_BACK",
  MATTER_RESPONSE = "MATTER_RESPONSE",
  PROCESS_FLOW_ANSWER = "PROCESS_FLOW_ANSWER",
  PROCESS_FLOW_SEND_BACK_ANSWER = "PROCESS_FLOW_SEND_BACK_ANSWER",
  NOTIFICATION = "NOTIFICATION"
}

export const translateEventType = (eventType: MatterEventTypes) => {
  if (eventType === MatterEventTypes.COMMENT) {
    return "Specialist jobbar med ärendet";
  } else if (eventType === MatterEventTypes.REGISTRATION) {
    return "Ärendet registrerades";
  } else if (eventType === MatterEventTypes.REASSIGNMENT) {
    return "Ärendet har skickats vidare";
  } else if (eventType === MatterEventTypes.REOPEN) {
    return "Ärendet har återöppnats";
  } else if (eventType === MatterEventTypes.CLOSE_MATTER) {
    return "Ärendet stängdes";
  } else if (eventType === MatterEventTypes.AMENDMENT) {
    return "Ärendet kompletterades av kundtjänst";
  } else if (eventType === MatterEventTypes.QUESTION) {
    return "Fråga har ställts till 3e part";
  } else if (eventType === MatterEventTypes.ANSWER) {
    return "Ärendesvar har registrerats";
  } else if (eventType === MatterEventTypes.ANSWERED) {
    return "3e part har besvarat en fråga";
  } else if (eventType === MatterEventTypes.DECISION_QUERY) {
    return "Beslutsbehov har ställts till 3e part";
  } else if (eventType === MatterEventTypes.DECIDED) {
    return "3e part har besvarat ett beslutsbehov";
  } else if (eventType === MatterEventTypes.APPROVED) {
    return "Ärende uppdaterades";
  } else if (eventType === MatterEventTypes.DENIED) {
    return "Ärende uppdaterades";
  } else if (eventType === MatterEventTypes.BEING_PREPARED) {
    return "Ärendet har fått förlängd hanteringstid";
  } else if (eventType === MatterEventTypes.MATTER_ANSWER) {
    return "Ärendet uppdaterades";
  } else if (eventType === MatterEventTypes.UNANSWERED) {
    return "Ärendet uppdaterades";
  } else if (eventType === MatterEventTypes.UNDECIDED) {
    return "Ärendet uppdaterades";
  } else if (eventType === MatterEventTypes.SENT_BACK) {
    return "Ärendet har skickats vidare";
  } else if (eventType === MatterEventTypes.ARCHIVE) {
    return "Ärendet är arkiverat";
  } else if (eventType === MatterEventTypes.MATTER_RESPONSE) {
    return "Ett ärendesvar har skapats";
  } else if (eventType === MatterEventTypes.PROCESS_FLOW_ANSWER) {
    return "Ärendet uppdaterades";
  } else if (eventType === MatterEventTypes.PROCESS_FLOW_SEND_BACK_ANSWER) {
    return "Ärendet uppdaterades";
  } else if (eventType === MatterEventTypes.NOTIFICATION) {
    return "Någon har notifierats om ditt ärende";
  }
};
